const React = require('react');

const {DEFAULT_CURRENCY} = require('../../../../../../../../constants/currencies');
const {DEFAULT_MERCHANT_ID} = require('../../../../../../../../constants/ids');
const withState = require('../../../../../../../../utils/withState');
const {apiAdminRetailerFlowGet, apiAdminMerchantUpdate, apiAdminRetailerFlowUpdate, apiAdminRetailerFlowReset,
  apiAdminRetailerGet, apiAdminRetailerUpdate
} = require("../../../../../../../../api/admin/retailers");
const {TrxProcessingForm} = require("../../../../../../../dumb/AdminHelpers/AdminConfigs");
const {PAYMENT_METHODS} = require("../../../../../../../../constants/paymentMethods");

module.exports = withState((setState, self, onMount) => {

  self.state = {
    ...self.state,
    loading: true
  }

  const getPageData = () => {
    const id = self.props.userId;
    const retailerData = apiAdminRetailerGet({id});
    const retailerGateway = apiAdminRetailerFlowGet({merchant_id: id});

    return Promise.all([retailerData, retailerGateway])
        .then(([retailerData, retailerGateway]) => {
          const initialErrors = {};
          const gateways = (retailerGateway.list || []).reduce((acc, next) => {
            acc[next.payment_method] = next.payment_gateway;

            const gatewayLists = (PAYMENT_METHODS[next.payment_method] || {}).gatewaysList || [];

            // console.log(next, gatewayLists);

            if (!gatewayLists.find(({id}) => id === next.payment_gateway)) {
              const availableNames = gatewayLists.map((el) => el.name).join(', ');
              initialErrors[next.payment_method] = `This method can only have ${availableNames} payment gateway`;
            }

            return acc;
          }, {});

          return ({
            data: {
              ...gateways,
              fiat_code: (retailerData.merchant || {}).fiat_code
            },
            initialErrors,
            gatewaysList: retailerGateway.list || [],
          })
        })
  }


  onMount(() => {
    getPageData().then(({data, initialErrors, gatewaysList}) => {
      const isGlobal = !(
        data.fiat_code !== DEFAULT_CURRENCY
        || gatewaysList.some((el) => el.merchant_id !== DEFAULT_MERCHANT_ID)
      );

      setState({data, initialErrors, isGlobal, loading: false});
    })
  })

  const onSubmit = async (data) => {
    const id = self.props.userId;
    const {fiat_code, confirmBearer, ...payload} = data;

    const retailerDataUpdate = apiAdminRetailerUpdate({id, merchant: {fiat_code}});
    const retailerGatewayUpdate = apiAdminRetailerFlowUpdate({merchant_id: id, payload, confirmBearer});

    return Promise.all([
      retailerDataUpdate,
      retailerGatewayUpdate
    ]);
  }

  const onResult = () => setState({isGlobal: false});

  const onGlobalInit = (confirmBearer) => {
    setState({loading: true});

    const id = self.props.userId;

    const retailerDataReset = apiAdminRetailerUpdate({merchant_id: id, fiat_code: DEFAULT_CURRENCY});
    const retailerGatewayReset = apiAdminRetailerFlowReset({merchant_id: id, confirmBearer});

    return Promise.all([
      retailerDataReset,
      retailerGatewayReset
    ])
        .then(getPageData)
        .then(({data}) => {
          setState({data, isGlobal: true})
        }).finally(() => {
          setState({loading: false});
        })
  }

  return ({loading, data, initialErrors, isGlobal}) => {
    return loading
      ? <span />
      : (
        <TrxProcessingForm
          data={data}
          initialErrors={initialErrors}
          onSubmit={onSubmit}
          onResult={onResult}
          onGlobalClick={onGlobalInit}
          disabledGlobal={isGlobal}
        />
      )
  }
})
